import { render, staticRenderFns } from "./notificationBox.vue?vue&type=template&id=6e320cea&scoped=true"
import script from "./notificationBox.vue?vue&type=script&lang=js"
export * from "./notificationBox.vue?vue&type=script&lang=js"
import style0 from "./notificationBox.vue?vue&type=style&index=0&id=6e320cea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e320cea",
  null
  
)

export default component.exports